var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"music",on:{"click":_vm.onMusicClick}},[_c('img',{attrs:{"src":_vm.active ? require('@/assets/mic.png') : require('@/assets/mic_step.png'),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }